import { categoryOf } from './FamilyDock';
import { slidingProductValue } from '../configurator/slidingOptions';

const groups = [['doors', 'Sliding doors'], ['windows', 'Fixed windows'], ['swing', 'Swing doors'], ['pivot', 'Pivot doors'], ['bifold', 'Bi-fold doors']];
export const productOptionLabel = product => product?.family === 'MT150' ? 'Sliding door' : product?.name;

export const ProductSelect = ({ id, testId, value, products, onChange, disabled }) => <>
  <label className="config-field" htmlFor={id}>Product</label>
  <select id={id} data-testid={testId} className="product-select" value={slidingProductValue(value)} disabled={disabled} onChange={event => onChange(event.target.value)}>
    {groups.map(([key, label]) => <optgroup key={key} label={label}>{products.filter(product => categoryOf(product) === key && (product.family !== 'MT150' || product.id === 'mt150-double')).map(product => <option key={product.id} value={product.id}>{productOptionLabel(product)}</option>)}</optgroup>)}
  </select>
</>;